import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController, ViewController, Events, PopoverController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';

/**
 * Generated class for the RegistroPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-moneda',
  templateUrl: 'moneda.html',
})
export class MonedaPage {
  monedas: any = []
  loading = false
  mone: any
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http : HttpProvider,
    public alrtCtrl : AlertController,
    public modal : ModalController,
    public viewCtrl: ViewController,
    public popCtrl: PopoverController,
    public events: Events
    ) {
      this.mone = window.localStorage.moneda
      this.loadMonedas()
  }

  loadMonedas(){
    this.loading = true
    this.http.get('tasas').subscribe(
      (res:any) => {
        this.loading = false
        this.monedas = [
          {value: res[0].tasa_v, label: 'BS', name: 'Bolívares'},
          {value: res[0].tasa_v, label: 'USD', name: 'USD Dólares'},
        ]
      },
      err => {
        console.log(err)
        this.loading = false
      }
    )
  }

  selectMoneda(moneda){
    window.localStorage.moneda = moneda.label
    this.mone = moneda.label
    window.localStorage.cambio = JSON.stringify(moneda.value)
    this.events.publish('moneda:update')
    this.viewCtrl.dismiss()
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/moneda/moneda.ts